var map = {
	"./Multicall.json": 488,
	"./PoolEarn3rdToken.json": 300,
	"./birthdayNftSale.json": 671,
	"./bond.json": 478,
	"./bondCommit.json": 362,
	"./bondLaunchpad.json": 570,
	"./bondLending.json": 615,
	"./bondLendingAbi.json": 357,
	"./bondStaking.json": 1744,
	"./bridgeAsset.json": 700,
	"./bridgeAssetPSC.json": 701,
	"./cake.json": 358,
	"./chainLinkPriceFeedAbi.json": 1071,
	"./claimRefund.json": 1745,
	"./convert_lp.json": 1746,
	"./erc20.json": 84,
	"./exchange-liquidity-pool-v2.json": 1747,
	"./exchange-liquidity-pool.json": 185,
	"./generalNFTReward.json": 163,
	"./generalNFTRewardNew.json": 512,
	"./generalRewardNFTv3.json": 1748,
	"./governanceAbi.json": 416,
	"./ifo.json": 702,
	"./liquidityNftStaking.json": 117,
	"./liquidityNftStakingDexV2.json": 270,
	"./liquidityNftStakingV2.json": 1749,
	"./liquidity_nft_manager.json": 318,
	"./lottery.json": 289,
	"./lotteryNft.json": 1750,
	"./lpToken.json": 703,
	"./marketplaceProxy.json": 1751,
	"./masterchef.json": 196,
	"./masterchefCake.json": 699,
	"./masterchefNew.json": 1752,
	"./masterchefv2.json": 1753,
	"./nfts.json": 1754,
	"./pancakeProfile.json": 1755,
	"./pancakeRabbits.json": 1756,
	"./pointCenterIfo.json": 1757,
	"./posi-router-swap.json": 612,
	"./posiBusdPair.json": 704,
	"./posiMarketplace.json": 705,
	"./posiNFTFactory.json": 180,
	"./posiNFTMintProxy.json": 706,
	"./posiNft.json": 378,
	"./posiTicketAbi.json": 707,
	"./positionBondRouter.json": 708,
	"./positionNondisperseLiquidity.json": 571,
	"./positionReferral.json": 361,
	"./positionStakingManagerLiquid.json": 709,
	"./sousChef.json": 417,
	"./sousChefBnb.json": 1758,
	"./spotHouseNewBond.json": 1759,
	"./spothouse/spotHousev1.json": 710,
	"./spothouse/spotHousev2.json": 711,
	"./syrup.json": 1760,
	"./vaultAbiBNB.json": 712,
	"./vaultAbiBNBNew.json": 1761,
	"./vaultAbiBUSD.json": 202,
	"./vaultAbiBUSDNew.json": 1762,
	"./weth.json": 1763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1053;